/*
 * @Author: yang_yang 1663724228@qq.com
 * @Date: 2023-03-20 09:23:27
 * @LastEditors: yang_yang 1663724228@qq.com
 * @LastEditTime: 2023-03-30 17:45:22
 * @FilePath: \jyh5\src\assets\i18n\zh\commApp\monthlyHealthReport.js
 * @Description: 健康月报
 */
const month = {
  health_report: "Health Report",
  day: "consecutive days.",
  month: "月",
  year: "年",
  years: "Annual",
  years_health_report: "Annual Health Report",
  time: "Time",
  times: "times",
  km: "km",
  hour: "hr",
  minute: "min",
  circle: "圈",
  step: "steps",
  w_step: "万步",
  score: "分",
  now_month: "This Month",
  last_month: "Last Month",
  keep_measure: "Consistent health checks and exercise can",
  can_keep_health: "assist in maintaining your health.",
  overview: "Overview",
  initiative_measure: "Number of self-initiated measurement",
  number_health: "Number of healthy results and the ratio",
  comm: "Normal",
  percent: "占比",
  overPercent: "正常比例超过",
  users: "of other users",
  allDistance: "Total Mileage",
  allDistance2: "Total Distance",
  average_sleep: "Average Sleep Duration",
  average_sleep2: "Average sleep duration",
  measure_statistics: "Measurement Statistics",
  now_month_measure: "Number of measurement this month",
  comm_times: "Healthy result ratio",
  compare_last_month: "Compare with last month",
  heart_rate: "Heart Rate",
  electrocardiograph: "ECG",
  blood_pressure: "Blood Pressure",
  sp: "Systolic",
  dp: "Diastolic",
  spo: "Blood Oxygen",
  pressure: "Fatigue",
  lowest: "Lowest",
  highest: "Highest",
  high: "High",
  high2: "High",
  low: "Low",
  low2: "Low",
  light: "Normal",
  middle: "Middle",
  max_continuous_heart_rate: "Highest record: heart rate detection for",
  sleep_statistics: "Sleep Condition Statistics",
  sport_statistics: "Exercise Statistics",
  outdoor_run: "Outdoor Run",
  indoor_run: "Indoor Run",
  walk: "Walking",
  swim: "Pool Swim",
  free_training: "Free Training",
  sportNum: "Total Times",
  sportTimes: "Total Duration",
  month_average_step: "Daily Average Steps of the Month",
  share_now: "Share",
  average_day_sleep: "Daily Avg.Sleep",
  average_day_light_sleep: "Daily Avg.Light Sleep",
  average_day_REM: "Daily Avg.REM",
  average_day_wake: "Daily Avg.Awake",
  no_data: "No Data",

  // 年报
  start: "Start",
  more_health_body: "你坚守更健康的自己",
  initiative_measure_num: "Number of self-initiated measurements",
  after_being_busy: "忙碌之余，",
  remember_measure: "还记得要坚持测量喔！",
  medical_treatment_statistics: "Measurement Frequency Statistics",
  measurement_analysis: "Measurement Analytics",
  comm_num: "正常次数",
  blood_pressure_comm_num: "Normal Blood Pressure",
  keep_measure_blood_pressure: "Prevention and treatment of blood pressure diseases require regular and constant blood pressure measurements.",
  spo_comm_num: "Normal Blood Oxygen",
  comm_precent: "Healthy result ratio",
  low_bp: "Low Blood Pressure",
  high_bp: "High Blood Pressure",
  low_spo: "Low Blood Oxygen",
  insufficient_spo: "Insufficient Oxygen Supply",
  know_spo: "Understand that blood oxygen reflects body's oxygen supply status.",
  light_pressure_num: "Low Fatigue",
  high_pressure_num: "High Fatigue",
  suitable_pressure: "A good amount of stress is helpful for improving people’s potential and efficiency.",
  night_sleep: "夜晚合理的睡眠结构，",
  daytime_vitality: "可以让您白天元气满满～",
  full_sleep: "You have sufficient sleep and you are doing better than",
  sleep_analyse: "Sleep Analysis",
  amount_run: "Equivalent to running",
  marathon: "marathons",
  now_year_walk: "本年度总步数",
  amount_around_earth: "相当于绕地球走了",
  year_distance: "Total Distance of the Year",
  year_measure: "Annual Measurement",
  index_comm_precent: "The Ratio of Healthy Results Statistics",

  month_list: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
};
export { month };



// WEBPACK FOOTER //
// ./src/assets/i18n/en/commApp/monthlyHealthReport.js